import React from "react";
import "../../styles/Home.css";

export default function UserDetails({ details }) {
  if (!details || details.length === 0) {
    return null;
  }

  return (
    <div className="user-details">
      {details.map((detail, index) => {
        const Icon = detail.icon;
        return (
          <div key={index} className="user-detail-item">
            <span className="user-detail-label">{detail.label}</span>
            <span className="user-detail-value">
              {Icon && <Icon />}
              {detail.value}
            </span>
          </div>
        );
      })}
    </div>
  );
}

